module.exports = __WEBPACK_EXTERNAL_MODULE_6__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"}
// module id = 6
// module chunks = 0


// WEBPACK FOOTER //
// webpack:/external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"}